module.exports = __webpack_public_path__ + "static/media/DEFAULT_MEDIUM_IMAGE_5.51e732c3.gif";